"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useInteractableHeight = require("@cbhq/cds-common/hooks/useInteractableHeight");
var _getFlexStyles = require("../layout/getFlexStyles");
var _media = require("../media");
var _system = require("../system");
var _linaria = require("../utils/linaria");
var _buttonStyles = require("./buttonStyles");
const _excluded = ["accessibilityLabel", "as", "onPress", "to", "alt", "src", "compact", "colorScheme", "shape", "selected", "name"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const AvatarButton = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let accessibilityLabel = _ref.accessibilityLabel,
    as = _ref.as,
    onPress = _ref.onPress,
    to = _ref.to,
    alt = _ref.alt,
    src = _ref.src,
    compact = _ref.compact,
    colorScheme = _ref.colorScheme,
    shape = _ref.shape,
    selected = _ref.selected,
    name = _ref.name,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const flexStyles = (0, _getFlexStyles.getFlexStyles)({
    alignItems: 'center',
    justifyContent: 'center'
  });
  const height = (0, _useInteractableHeight.useInteractableHeight)(compact);
  const style = (0, _react.useMemo)(() => ({
    '--interactable-height': `${height}px`
  }), [height]);
  return /*#__PURE__*/_react.default.createElement(_system.PressableOpacity, _extends({
    "aria-label": accessibilityLabel
  }, props, {
    ref: ref,
    as: as,
    className: (0, _linaria.cx)(flexStyles, _buttonStyles.avatarButton),
    onPress: onPress,
    style: style,
    to: to
  }), /*#__PURE__*/_react.default.createElement(_media.Avatar, {
    alt: alt,
    colorScheme: colorScheme,
    dangerouslySetSize: height,
    name: name,
    selected: selected,
    shape: shape,
    src: src
  }));
}));
exports.AvatarButton = AvatarButton;